import { useState } from "react";
import personaServicio from "../../services/persona/personaServicio";
import { IResponsePost } from "../../Interfaces/base/IResponse";
import { useBoolean } from "@fluentui/react-hooks";

export const useRegistrarSupervisorSuplente = (onDismissPanel) => {
  const [response, setResponse] = useState<IResponsePost>(null!);
  const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] =
    useBoolean(false);

  const postRegistrarSuplente = (modelo: any) => {
    ocultarMensaje();
    onEnviar();
    personaServicio
      .postSuplente(modelo)
      .then((res) => {
        if (res.status === 200) {
          setResponse({
            codigoMensaje: res.data.codigoMensaje,
            mensaje: res.data.mensaje,
          });
          onCancelar();
          if (res.data.codigoMensaje === 1) {
            setTimeout(() => {
              onDismissPanel();
            }, 2500);
          }
        }
      })
      .catch((err) => {
        onCancelar();
        console.log(err);
      });
  };
  const ocultarMensaje = () => {
    setResponse(null!);
  };
  return {
    ocultarMensaje,
    response,
    isSend,
    postRegistrarSuplente,
  };
};
